import { AuthLayout } from "../components/ui/auth-layout"
import { SignUpForm } from "../components/auth/signup-form"

export default function SignUpPage() {
  return (
    <AuthLayout
      title="Create Account"
      subtitle="Join thousands of healthcare professionals using VirtualScribe"
      showBackButton={true}
    >
      <SignUpForm />
    </AuthLayout>
  )
}
